@if (isInPlayBreak) {
    <show-message [type]="messageType.INFO">
        <div info>
            <strong>{{ 'PARTY.CASHIER.web.play.break.header' | translate }}</strong>
            <p>{{ 'PARTY.CASHIER.web.play.break.message' | translate }}</p>
        </div>
    </show-message>
}
